// extracted by mini-css-extract-plugin
export var card = "_pv-0";
export var content = "_pv-2";
export var details = "_pv-3";
export var icon = "_pv-1";
export var iconBlue = "_pv-5";
export var iconBrand = "_pv-4";
export var iconGrayBlue = "_pv-6";
export var iconGreen = "_pv-7";
export var iconIndigo = "_pv-8";
export var iconOrange = "_pv-9";
export var iconPurple = "_pv-a";
export var iconRed = "_pv-b";
export var iconWarning = "_pv-c";